import { Injectable } from '@angular/core';

@Injectable()
export class FilterService {
  public getFilteredText(filterOptions: any, url: string): string {
    //Handle filtered text
    if (filterOptions) {
      if (filterOptions['filteredText'] != undefined) {
        const healthCenters: string[] = [];

        for (let key of Object.keys(filterOptions)) {
          if (key === 'filteredText' && filterOptions[key]) healthCenters.push(filterOptions[key]);
        }

        let healthCenterString: string = '';
        for (var i = 0; i < healthCenters.length; i++) {
          if (i == healthCenters.length - 1) {
            healthCenterString += healthCenters[i];
          } else {
            healthCenterString += healthCenters[i] + ',';
          }
        }
        url += '&healthCenter=' + healthCenterString;
      }
    }

    return url;
  }
}
